<template>
  <div>
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }"
        >我的报名</el-breadcrumb-item
      >
      <el-breadcrumb-item class="zpgg">打印笔试准考证</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter">
        <div class="report_box" id="printTest">
          <h3>
            《<span>{{ list.news_name }}</span
            >》
            <p>笔试准考证</p>
          </h3>

          <ul class="report_box_ul">
            <li>
              考生姓名：<span>{{ list.real_name }}</span>
            </li>
            <li>性&emsp;&emsp;别：{{ list.sex == 1 ? "男" : "女" }}</li>
            <li>
              证件号码：<span>{{ list.id_card }}</span>
            </li>
            <li>
              准考证号：<span>{{ list.zkz_num }}</span>
            </li>
            <li class="box_li">
              <span class="box_li_span"
                >报考岗位：<span>{{ list.post_name }}</span></span
              ><span class="box_li_span1"
                >岗位编号：<span>{{ list.post_code }}</span></span
              >
            </li>
            <li>
              考试时间：<span>{{ list.exam_time }}</span>
            </li>
            <li>
              考试地点：<span>{{ list.exam_address }}</span>
            </li>
            <li>
              考试科目：<span>{{ list.exam_subject }}</span>
            </li>
            <div class="ul_div" v-if="list.id_photo">
              <img :src="list.id_photo" style="width: 100%" alt="" />
            </div>
            <div class="ul_div" v-else>近期免冠照片</div>
          </ul>
          <div class="line"></div>

          <div class="report_text">
            <h4>考试须知</h4>
            <div class="examnotes">
              {{ list.exam_notes }}
              </div>
            <!-- <p class="p_one">
                         一、应试人员在考试开始前30分钟，请携带好本人<span>学历证明材料</span>，凭本人<span>准考证</span>（自行打印）和有效的居民<span>身份证</span>进入考场，对号入座，并将准考证及身份证放在桌面右上角。
                       </p>
                       <p>
                         二、考试开始25分钟后不得进入考场，考试开始30分钟后才能交卷退场。退场后不得再次进入考场。
                       </p>
                       <p>
                         三、考试期间，任何人不得交头接耳、大声喧哗、将试卷内容和答题信息传出考场。
                       </p>
                       <p class="p_two">
                         四、应试人员必<span>须遵守本考场规则</span>，服从监考人员的管理。否则，按考试违纪违规行为处理。
                       </p>
                       <p>
                         五、考生如有疑问，请联系安徽省环安人才服务有限公司现场考务工作人员。
                       </p>
                       <h5>安徽省环安人才服务有限公司&emsp;&emsp;监制</h5> -->
          </div>

          <div
            style="
              text-align: center;
              z-index: -1;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            "
          >
            <img src="../assets/img/haa.jpg" style="width: 50%" alt="" />
          </div>
        </div>
        <div class="re_btm">
          <button v-print="'#printTest'" @click="printNotify(post_id, 103)">
            打印
          </button>
        </div>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      list: {},
      post_id: 0,
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query = this.$route.query;
    this.post_id = query.post_id;
    this.getInfo(this.post_id, 103);
  },
  watch: {},
  methods: {
    getInfo(id, code) {
      let _this = this;
      _this
        .request("api/post_up_info", { post_id: id, code: code }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            this.list = res.data.data.info;
          }
        });
    },

    //打印后通知服务器
    printNotify(id, code) {
      let _this = this;
      _this
        .request("api/sign_up/print", { post_id: id, code: code }, "post")
        .then(() => {
          _this.$router.push("/step?post_id=" + id);
        });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
.report_box {
  position: relative;
  // background-image: url("../assets/img/haa.jpg");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: 33%;
  // background-position-y: center;
}
.report_box > h3 {
  font-size: 0.3rem;
  text-align: center;
  color: #393939;
  padding-bottom: 0.5rem;
}
.report_box > h3 > span {
  color: red;
}
.report_box_ul {
  position: relative;
  // padding: 0 0.8rem;
}
li {
  font-size: 0.16rem;
  padding: 0.15rem 0;
}
li:nth-of-type(1) {
  font-size: 0.28rem;
}
li > span {
  color: #000;
}
.box_li {
  display: flex;
}
.box_li > .box_li_span {
  flex: 0.5;
}

.box_li > .box_li_span1 {
  flex: 1;
}

.ul_div {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.58rem;
  height: 2.1rem;
  border: solid 1px #333;
  // margin-right: 0.8rem;
  text-align: center;
  line-height: 2.1rem;
}
.line {
  width: 100%;
  border: solid 1px #000;
  // margin-left: 0.8rem;
}
.report_text {
  // padding-left: 0.8rem;
}
.examnotes{
  white-space:pre-wrap;
}
.report_text > h4 {
  font-size: 0.3rem;
  font-weight: 500;
  padding: 0.2rem 0;
}
.report_text > h5 {
  text-align: center;
  font-size: 0.16rem;
  padding: 0.2rem 0;
}
.report_text > p {
  font-size: 0.16rem;
  padding: 0.1rem 0;
}
.report_text > .p_one > span {
  font-weight: 600;
}
.report_text > .p_two > span {
  font-size: 0.3rem;
}
.tac {
  .conter {
    padding: 0 0.8rem;
    .re_btm {
      text-align: center;
      padding: 0.8rem 0;
      button {
        width: 3.28rem;
        height: 0.78rem;
        background-color: #00a0e9;
        color: #fff;
        font-size: 0.37rem;
        border-radius: 0.1rem;
      }
    }
  }
}
</style>
